import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=6c768b83&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=6c768b83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c768b83",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BNavbarBrand, BNavItem, BNav, BSidebar} from 'bootstrap-vue'
    installComponents(component, {BNavbarBrand, BNavItem, BNav, BSidebar})
    

export default component.exports